import { parseTime } from '@/utils/index'

export function parseTimeFormatter(row, column, value, index) {
  return parseTime(value)
}
